import { createReducer } from '@reduxjs/toolkit';

import {
    changePasswordError,
    changePasswordSubmit,
    closeChangePasswordModal,
    openChangePasswordModal,
} from './change-password-actions';

export interface ChangePasswordState {
    isChangePasswordModalOpen: boolean;
    hasError: boolean;
}

const initialState: ChangePasswordState = {
    isChangePasswordModalOpen: false,
    hasError: false,
};

export const changePasswordReducer = createReducer(initialState, builder => {
    builder.addCase(openChangePasswordModal, state => ({ ...state, isChangePasswordModalOpen: true, hasError: false }));
    builder.addCase(closeChangePasswordModal, state => ({ ...state, isChangePasswordModalOpen: false }));
    builder.addCase(changePasswordSubmit, state => ({ ...state, hasError: false }));
    builder.addCase(changePasswordError, state => ({ ...state, hasError: true }));
});
